import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const Menu = styled.div<{ $open: boolean }>`
  background-color: ${colors.primary.white};

  & > div {
    display: flex;
    flex-direction: row;
    gap: 0px;
  }

  .footer-content {
    width: 300px;
    transition: width 0.3s ease-in-out;
  }
`;

export const Configuration = styled.div`
  width: 320px;
  gap: 0px;
  padding: 20px;
  h2 {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const Footer = styled.div`
  width: 100%;
  justify-content: center;
  border-top: 1px solid ${colors.secondary.lightGray3};
  padding: 10px;
  & > div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const ImageTemplateWrapper = styled.div<{ $open: boolean }>`
  width: ${({ $open }) => ($open ? '450px' : '0px')};
  overflow: hidden;
  gap: 0px;
  border-left: 1px solid ${colors.secondary.lightGray3};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition:
    width 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  & > div {
    transform: scaleX(${({ $open }) => ($open ? 1 : 0)});
    transition: transform 0.3s ease-in-out;
  }
`;

export const EditScriptLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;
  color: ${colors.semantic.link};
  cursor: pointer;
`;

export const ImageTemplate = styled.div`
  display: flex;
  flex-direction: column;
  /* background: ${colors.secondary.lightGray1}; */
  width: 450px;
  gap: 10px;
  padding: 20px;
  h2 {
    font-size: 18px;
    font-weight: bold;
  }
`;

export const ScriptEditorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 220px;
`;

export const ScriptEditor = styled.div`
  border: 1px solid ${colors.secondary.lightGray3};
  border-radius: 4px;
  height: 220px;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  font-weight: 500;

  & > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
`;

export const Pricing = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;

  span {
    font-weight: normal;
    font-size: 11px;
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GpuOptionValue = styled.div<{}>`
  /* display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px; */

  .item {
    /* border: 1px solid red; */
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
  }

  .label {
    /* font-weight: bold; */
  }

  .cost-per-hour {
    font-size: 11px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
